export const PARTNER_LINK_TTL_DAYS = 90;

export const PARTNER_LINK_TTL_MS = PARTNER_LINK_TTL_DAYS * 24 * 60 * 60 * 1000;

// Undated: written before bp_id_captured_at existed, its age cannot be known.
export const isCookieBpIdFresh = (
  capturedAt: unknown,
  now: number = Date.now()
): boolean => {
  if (capturedAt === undefined) return true;
  return (
    typeof capturedAt === "number" &&
    Number.isFinite(capturedAt) &&
    // A date ahead of now has a negative age, which would never reach the TTL.
    capturedAt <= now &&
    now - capturedAt <= PARTNER_LINK_TTL_MS
  );
};

export const readUtmDatasCookie = (
  raw: unknown,
  now: number = Date.now()
): Record<string, any> => {
  let parsed: unknown = raw;
  if (typeof raw === "string") {
    if (raw === "") return {};
    try {
      parsed = JSON.parse(raw);
    } catch {
      return {};
    }
  }
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return {};

  const data: Record<string, any> = { ...(parsed as Record<string, any>) };
  if (!isCookieBpIdFresh(data.bp_id_captured_at, now)) delete data.bp_id;
  delete data.bp_id_captured_at;
  return data;
};
